import { DefaultProps } from '../../types/DefaultProps';
import { FortuneTellingResult } from '../../types/FortuneTellingResult';
import { BlockInnerFortuneTelling } from '../Block/BlockInnerFortuneTelling';
import { GoogleAdManagerSlot } from '../GoogleAdManagerSlot';
import { InnerMargin } from '../Layout/InnerLayout/InnerMargin';

import { BannerGroup } from './BannerGroup';
import { BannerProps } from './BannerProps';
import styles from './SideMenu.module.scss';
import {
  defaultUpperBannerList,
  defaultBottomBannerList,
} from './defaultParams';

import type { LoggedInUser } from '../../types/LoggedInUser';
import type { AppEnv } from '@/packages/nurse-senka-frontend-sdk';
import type { FC } from 'react';

export type SideMenuMyPageProps = DefaultProps & {
  appEnv: AppEnv;
  loggedInUser: LoggedInUser;
  fortuneTellingResult: FortuneTellingResult;
  upperBannerList?: BannerProps[];
  bottomBannerList?: BannerProps[];
};

export const SideMenuMyPage: FC<SideMenuMyPageProps> = ({
  fortuneTellingResult,
  upperBannerList = defaultUpperBannerList,
  bottomBannerList = defaultBottomBannerList,
}) => (
  <div className={styles.wrap}>
    <InnerMargin align="default">
      <BlockInnerFortuneTelling fortuneTellingResult={fortuneTellingResult} />
    </InnerMargin>
    <div className={styles.block}>
      <GoogleAdManagerSlot
        key="div-gpt-ad-1426472053621-0"
        id="div-gpt-ad-1426472053621-0"
      />
      <GoogleAdManagerSlot
        key="div-gpt-ad-1426470100054-7"
        id="div-gpt-ad-1426470100054-7"
      />
    </div>
    <div className={styles.block}>
      <BannerGroup bannerPropsList={upperBannerList} />
    </div>

    <div className={styles.block}>
      <BannerGroup bannerPropsList={bottomBannerList} />
    </div>

    <GoogleAdManagerSlot
      key="div-gpt-ad-1426470100054-9"
      id="div-gpt-ad-1426470100054-9"
    />
  </div>
);
